import IconoInstagram from './IconoInstagram';
import { marca, contacto } from '../data/contenido';

export default function Pie() {
  return (
    <footer className="pie">
      <div className="envoltura pie__fila">
        <span>
          {marca.nombre} {marca.bajada}
        </span>
        <span>{marca.lugar}</span>
        <a className="pie__instagram" href={contacto.instagramUrl} target="_blank" rel="noreferrer">
          @{contacto.instagram}
          <IconoInstagram tamano={12} />
        </a>
        <span>© {new Date().getFullYear()}</span>
      </div>
    </footer>
  );
}
